// Two-panel brand statement — LEFT: solid black with copy + hand-holding-fabric
// rising from the bottom-centre. CENTRE: full-height gold gradient stripe.
// RIGHT: bridal-model image with a floating translucent sale card.
export const BrandStatement = () => (
  <section
    className="relative bg-black overflow-hidden"
    data-testid="brand-statement"
    aria-labelledby="brand-statement-heading"
  >
    {/* Grid: two equal columns split by the gold stripe */}
    <div className="relative grid grid-cols-2 min-h-[560px] sm:min-h-[640px] lg:min-h-[720px]">
      {/* LEFT — solid black panel */}
      <div className="relative bg-black flex items-center">
        <div className="pl-[8%] pr-[12%] max-w-xl">
          <p className="font-sans text-[11px] sm:text-xs uppercase tracking-[0.28em] text-white/55">
            Statement, Timeless, <span className="text-white/70">Zebaa</span>.
          </p>
          <h2
            id="brand-statement-heading"
            className="font-sans font-semibold tracking-tight text-3xl sm:text-4xl lg:text-[3rem] leading-[1.1] text-white mt-5"
          >
            The New{" "}
            <span
              style={{
                backgroundImage:
                  "linear-gradient(90deg, #C9A24B 0%, #E4C87F 55%, #EAD8A0 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              Gold Standard
            </span>
            <br />
            of Jewellery.
          </h2>
        </div>
      </div>

      {/* RIGHT — bridal model with translucent floating sale card */}
      <div className="relative bg-black overflow-hidden">
        <img
          src="/brand-lady.png"
          alt="Zebaa bridal model wearing kundan-style earring"
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover object-[70%_center]"
        />
        {/* Left-side fade so the floating card reads on any image content */}
        <div className="absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

        <div className="absolute top-1/2 left-[8%] -translate-y-1/2 w-[62%] max-w-md bg-black/55 backdrop-blur-[2px] px-7 py-8 sm:px-9 sm:py-10">
          <p className="font-sans text-[13px] sm:text-[15px] leading-relaxed text-white/85">
            Sale is live, save up to 50% on selected bridal sets, kundan-style
            necklaces and gold-tone bangles, with new pieces added weekly.
          </p>
          <a
            href="/shop/sale"
            data-testid="brand-statement-sale-cta"
            className="inline-flex items-center gap-2 mt-6 font-sans text-sm font-semibold text-white border-b border-white/40 hover:border-white pb-1 transition-colors"
          >
            Shop the Sale <span aria-hidden="true">-&gt;</span>
          </a>
          <p className="font-sans text-[10px] sm:text-[11px] uppercase tracking-[0.24em] text-white/40 mt-10">
            *Limited time: Sale now on
          </p>
        </div>
      </div>

      {/* CENTRE gold gradient stripe (behind the hand, in front of the panels) */}
      <div
        aria-hidden="true"
        className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-[56px] sm:w-[76px] lg:w-[90px] z-10 pointer-events-none"
        style={{
          background:
            "linear-gradient(to bottom, #C9A24B 0%, #E4C87F 22%, #EAD8A0 52%, rgba(234,216,160,0.45) 78%, rgba(234,216,160,0.15) 100%)",
        }}
      />

      {/* HAND holding fabric — rises from the bottom, centred on the gold stripe */}
      <img
        src="/brand-hand.png"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[46%] sm:w-[42%] lg:w-[38%] max-w-[560px] h-auto z-20 pointer-events-none select-none"
        style={{ marginLeft: "-6%" }}
      />
    </div>
  </section>
);
